<template>
  <auth-layout pageClass="login-page">
    <div
      class="row d-flex justify-content-center"
      id="topDiv"
    >
      <div class="col-md-10">
        <div
          class="card card-wizard"
          id="wizardCard"
        >
          <div
            class="row"
            v-if="loadingSubscriptionPlan"
            v-loading="loadingSubscriptionPlan"
            id="loading"
          ></div>
          <form-wizard
            shape="tab"
            v-if="!loadingSubscriptionPlan"
            :title="'Inscrição ' + subscriptionPlan.name"
            subtitle="Preecha o seguinte formulário"
            @on-complete="wizardComplete"
            error-color="#FB404B"
            color="#35495E"
          >
            <tab-content
              title="Dados Pessoais"
              class="col-12"
              :before-change="() => validateStep('firstStep')"
              icon="nc-icon nc-badge"
            >
              <first-step
                ref="firstStep"
                @on-validated="onStepValidated"
              ></first-step>
            </tab-content>

            <tab-content
              title="Dados de Pagamento"
              class="col-12"
              :before-change="() => validateStep('secondStep')"
              icon="nc-icon nc-notes"
            >
              <second-step
                ref="secondStep"
                :subscriptionPlan="subscriptionPlan"
                @on-validated="onStepValidated"
              ></second-step>
            </tab-content>

            <tab-content
              title="Finalizar"
              class="col-12"
              icon="nc-icon nc-check-2"
            >
              <div v-if="!loadingRegistration">
                <h2 class="text-center text-space">
                  Falta pouco, {{this.wizardModel.name}}!
                  <br>
                  <small>
                    Clique em
                    <b>Finalizar</b> para se juntar a maior comunidade de traders do Brasil.
                  </small>
                </h2>
              </div>
              <div
                class="row"
                v-if="loadingRegistration"
                v-loading="loadingRegistration"
                id="loading"
              ></div>
            </tab-content>

            <button
              slot="prev"
              class="btn btn-default btn-fill btn-wd btn-back"
            >Voltar</button>
            <button
              slot="next"
              class="btn btn-default btn-fill btn-wd btn-next"
            >Continuar</button>
            <button
              slot="finish"
              class="btn btn-success btn-fill btn-wd"
            >Finalizar</button>
          </form-wizard>
        </div>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import Vue from 'vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { Loading } from 'element-ui'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import AuthLayout from './AuthLayout.vue'
import FirstStep from './WizardRecurringForms/FirstStep.vue'
import SecondStep from './WizardRecurringForms/SecondStep.vue'
import swal from 'sweetalert2'

Vue.use(Loading.directive)

export default {
  data () {
    return {
      wizardModel: {
        operation_type: 'NEW_CUSTOMER',
        salesman_id: this.salesmanId,
        plan_id: this.planId
      },
      loadingRegistration: false,
      loadingSubscriptionPlan: false,
      subscriptionPlan: {}
    }
  },
  props: {
    planId: String,
    salesmanId: String
  },
  components: {
    AuthLayout,
    FormWizard,
    TabContent,
    FirstStep,
    SecondStep
  },
  methods: {
    validateStep (ref) {
      return this.$refs[ref].validate()
    },
    onStepValidated (validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model }
    },
    wizardComplete () {
      var paymentProfile = {
        holder_name: this.wizardModel.customer_card_name,
        card_expiration:
          this.wizardModel.customer_card_expiry_month +
          '/' +
          this.wizardModel.customer_card_expiry_year,
        card_number: this.wizardModel.customer_card_number,
        card_cvv: this.wizardModel.customer_card_cvc,
        payment_method_code: 'credit_card',
        payment_company_code: this.wizardModel.customer_card_type
      }

      this.loadingRegistration = true

      // set vindi's public key.
      const VINDI_PUBKEY = process.env.VUE_APP_VINDI_PUBKEY
      const VINDI_URL = process.env.VUE_APP_VINDI_URL

      this.axios({
        method: 'post',
        url: VINDI_URL + 'payment_profiles',
        dataType: 'json',
        headers: {
          Authorization:
            'Basic ' + btoa(VINDI_PUBKEY + ':')
        },
        data: paymentProfile
      })
        .then(response => {
          delete this.wizardModel.customer_card_name
          delete this.wizardModel.customer_card_number
          delete this.wizardModel.customer_card_cvc
          delete this.wizardModel.customer_card_expiry_month
          delete this.wizardModel.customer_card_expiry_year
          delete this.wizardModel.customer_card_type

          this.wizardModel = { ...this.wizardModel, ...response.data.payment_profile }

          this.axios
              .patch('/vindi', this.wizardModel)
              .then(response => {
                this.loadingRegistration = false
                if (response.status == '200') {
                  swal({
                    title: 'Inscrição realizada com sucesso!',
                    text: 'Após a confirmação de pagamento, você poderá aproveitar o melhor conteúdo trader do Brasil.',
                    type: 'success',
                    confirmButtonText: 'Ok!',
                    confirmButtonColor: '#002c44'
                  }).then(result => {
                    setTimeout(function () {
                      window.location.href = 'https://top-trader.org'
                    }, 100)
                  })
                }
              })
              .catch(error => {
                this.loadingRegistration = false
                swal({
                  title: 'Falha ao processar inscrição!',
                  text: 'Entre em contato com o suporte.',
                  type: 'error',
                  confirmButtonText: 'Ok! Ir para Chat',
                  confirmButtonColor: '#FB404B'
                }).then(result => {
                  setTimeout(function () {
                    window.location.href = 'https://api.whatsapp.com/send?phone=5591991133258'
                  }, 100)
                })
              })
        })
        .catch(error => {
          this.loadingRegistration = false
          swal({
            title: 'Cartão Recusado!',
            text:
              'Verifique os dados de pagamento ou entre em contato com sua administradora de cartões',
            type: 'error',
            confirmButtonText: 'Ok! Tentar Novamente',
            confirmButtonColor: '#FB404B'
          })
          console.log(error)
        })
    },
    getSubscriptionPlan () {
      this.loadingSubscriptionPlan = true
      this.planId = this.planId || process.env.VUE_APP_VINDI_DEFAULT_PLANID
      this.wizardModel.plan_id = this.planId
      this.axios
        .get('/vindi/' + this.planId)
        .then(response => {
          if (response.data) {
            this.loadingSubscriptionPlan = false
            this.subscriptionPlan = response.data
          } else {
            swal({
              title: 'Falha ao carregar dados de inscrição!',
              text: 'Tente Novamente',
              type: 'error',
              confirmButtonText: 'Ok! Recarregar Página',
              confirmButtonColor: '#FB404B'
            }).then(result => {
              setTimeout(function () {
                location.reload()
              }, 100)
            })
          }
        }).catch(error => {
          swal({
            title: 'Falha ao carregar dados de inscrição!',
            text: 'Tente Novamente',
            type: 'error',
            confirmButtonText: 'Ok! Recarregar Página',
            confirmButtonColor: '#FB404B'
          }).then(result => {
            setTimeout(function () {
              location.reload()
            }, 100)
          })
          console.log(error)
        })
    }
  },
  created () {
    this.getSubscriptionPlan()
  }
}
</script>
<style lang="scss">
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
  .el-loading-spinner .path {
    stroke: #002c44 !important;
  }

  .el-loading-mask {
    background: transparent !important;
  }
}
.vue-form-wizard .wizard-icon-circle.tab_shape {
  background-color: #9a9a9a !important;
  color: white;
}
.vue-form-wizard .wizard-tab-content {
  display: flex; // to avoid horizontal scroll when animating
  .wizard-tab-container {
    display: block;
    animation: fadeIn 0.5s;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/RegisterRecurringUser.vue